import { Component, OnInit } from '@angular/core';
import { FamilyRegistrationService } from '../family-registration.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { EmailNotSentComponent } from '../email-not-sent/email-not-sent.component';
import { LoginService } from '../../login/login.service';

@Component({
  selector: 'app-link-already-sent',
  templateUrl: './link-already-sent.component.html',
  styleUrls: [
      './link-already-sent.component.css',
      '../familiy-registration-shared-style.css'
    ]
})
export class LinkAlreadySentComponent implements OnInit {
registerNewFamily: any;

  constructor(
    private familyRegistrationService: FamilyRegistrationService,
    private dialogRef: MatDialogRef<LinkAlreadySentComponent>,
    private dialog: MatDialog,
    private loginService: LoginService
  ) { }
  enableSelfRegistrationCode = false;
  ngOnInit() {
    this.registerNewFamily = this.familyRegistrationService.registerNewFamily;
    this.enableSelfRegistrationCode  = this.loginService.LoginSettings.EnableSelfRegistrationCode;
  }

  modalInstanceYesClick() {
    this.dialogRef.close('Yes was clicked.');
    this.familyRegistrationService.sendRegisterParentEmail(this.registerNewFamily.emailAddress, this.registerNewFamily.languageId, window.location.href).subscribe(
      (result) => {
        if (!result) {
          const emailNotSentDialog = this.dialog.open(EmailNotSentComponent, {
            panelClass: 'tyl-mat-dialog',
          });
        }
      },
      () => {
        const emailNotSentDialog = this.dialog.open(EmailNotSentComponent, {
          panelClass: 'tyl-mat-dialog',
        });
      }
    );
}

modalInstanceCloseClick() {
    this.dialogRef.close('Close was clicked.');
}
}
